import { Injectable } from '@angular/core';
import { ServiceBase } from './service.base';
import { IEstoque } from '../models/estoque';
import { EstoqueApi } from '../api/estoque.api';
import { IEstoqueDTO } from '../dto/estoque-dto';

@Injectable()
export class EstoqueService extends ServiceBase<IEstoque, IEstoqueDTO> {

  constructor(api: EstoqueApi) {
    super(api);
  }
}
